var $f8b1a75b07b20cfe$exports = {};
$f8b1a75b07b20cfe$exports = {
    "maximum": `Maximum`,
    "minimum": `Minimum`
};


export {$f8b1a75b07b20cfe$exports as default};
//# sourceMappingURL=cs-CZ.module.js.map
